import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Laptop } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { canSeeInventory, typeLabel } from "../../lib/procurement";
import { Card } from "../ui/card";
import { LoanNote, StatusBadge, WarrantyNote } from "./ProcurementBits";

// « Matériel chez la pharmacie » on the customer file (Ordre 20): the assets whose holder is this pharmacy. Only for a reader of the
// inventory (assets:view); never a cost, funder or serial number here — the asset page shows them to whoever holds those keys. Being the
// account manager of the customer shows nothing of it (D-62). Nothing at all when the pharmacy holds nothing.
export default function PharmacyAssetsCard({ prospectId }) {
  const { user } = useAuth();
  const visible = canSeeInventory(user);
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!visible) return undefined;
    let alive = true;
    api.get("/procurement/assets", { params: { holder: `pharmacy:${prospectId}`, status: "active", limit: 50 } })
      .then(({ data }) => { if (alive) setItems(data.items); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [visible, prospectId]);
  if (!visible || !items || items.length === 0) return null;
  return (
    <Card className="p-5 space-y-3" data-testid="pharmacy-assets-card">
      <h3 className="flex items-center gap-2 font-semibold text-slate-900"><Laptop size={16} className="text-slate-400" />Matériel chez la pharmacie</h3>
      <ul className="divide-y divide-slate-100">
        {items.map((a) => (
          <li key={a.id}>
            <Link to={`/achats/actifs/${a.id}`} className="flex items-start justify-between gap-2 -mx-2 px-2 py-2 rounded-lg hover:bg-slate-50" data-testid={`pharmacy-asset-${a.number}`}>
              <div className="min-w-0 space-y-1">
                <div className="text-sm font-medium text-slate-900 break-words">{[a.brand, a.model].filter(Boolean).join(" ") || a.label || typeLabel(a.type)}</div>
                <div className="text-xs text-slate-500">{a.number} · {typeLabel(a.type)}</div>
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1"><StatusBadge status={a.status} /><LoanNote asset={a} /><WarrantyNote asset={a} /></div>
              </div>
              <ChevronRight size={16} className="text-slate-300 shrink-0 mt-1" />
            </Link>
          </li>
        ))}
      </ul>
    </Card>
  );
}
